const t = "Druk op Tab om naar de pop-over te gaan", r = {
  triggerHint: t
};
export {
  r as default,
  t as triggerHint
};
